import React, { useCallback } from 'react'
import { ButtonProps } from '@shared/components/button/model'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import { Button } from '@shared/componentsStyled/Button'
import { yaCounter } from '@shared/pipes/ya-counter'
import styled from 'styled-components'

import { goToActivateLink } from './SectionActivate'

const logRegisterMain = (): void => yaCounter.utils.reachGoal('invest_register_main')

export interface MainProps {
	buttonProps?: ButtonProps
}

export function SectionMain({ buttonProps }: MainProps): JSX.Element {
	const onClick = useCallback(
		(event) => {
			logRegisterMain()
			return buttonProps?.onClick?.(event)
		},
		[buttonProps?.onClick]
	)
	return (
		<Section>
			<ViewRoot>
				<ViewContent>
					<TextTitle>
						Подарок,
						<br />
						который
						<br />
						зарабатывает
					</TextTitle>
					<Text>
						Сертификат на Сбережение от 10 тысяч рублей для ценителей необычных и полезных
						поздравлений.
					</Text>
					<ButtonStyled id={buttonProps?.id} onClick={onClick}>
						Купить сертификат
					</ButtonStyled>
					<TextSubTitle>Вам подарили сертификат?</TextSubTitle>
					<TextLink onClick={goToActivateLink}>Активировать его!</TextLink>
				</ViewContent>
				<ViewImage>
					<Image name='invest_gift.png' alt='Подарок, который зарабатывает.' />
				</ViewImage>
			</ViewRoot>
		</Section>
	)
}

const ViewRoot = styled.div(({ theme }) => ({
	display: 'flex',
	backgroundColor: theme.colors.lightmint,
	borderRadius: 20,
	marginBottom: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		borderRadius: 40,
	},
}))

const ViewContent = styled.div(({ theme }) => ({
	flex: 1,
	padding: 20,
	zIndex: 1,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		paddingTop: 40,
		paddingLeft: 60,
		paddingRight: 0,
		maxWidth: '45%',
		marginRight: 'auto',
	},
}))
const ViewImage = styled.div(({ theme }) => ({
	display: 'none',
	flex: 1,

	picture: {
		[theme.mediaQueries.mediaMinWidthDesktop]: {
			display: 'flex',
			height: '100%',
			width: '100%',
		},
	},

	alignItems: 'center',
	justifyContent: 'flex-end',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		display: 'flex',
	},
}))

const TextTitle = styled.h1(({ theme }) => ({
	...theme.typography.header30_36,
	marginBottom: 10,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header56_60,
		marginBottom: 20,
	},
}))

const Text = styled.p(({ theme }) => ({
	...theme.typography.text18_24,
	marginBottom: 15,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.text24_32,
		marginBottom: 30,
	},
}))

const ButtonStyled = styled(Button)(() => ({
	marginBottom: 30,
}))

const TextSubTitle = styled.p(({ theme }) => ({
	...theme.typography.text24_32,
	fontWeight: 'bold',
}))

const TextLink = styled.div(({ theme }) => ({
	...theme.typography.text24_32,
	whiteSpace: 'nowrap',
	display: 'inline-block',
	color: theme.colors.main,
	cursor: 'pointer',
	'&:hover': {
		color: theme.colors.buttonhover,
	},
	'&:active': {
		color: theme.colors.buttonpressed,
	},
}))
